import * as React from 'react'

import { Text } from 'main/ui'

interface IProps {
  email: string
}

function ForgotPasswordSuccess(props: IProps) {
  const { email } = props

  return (
    <Text>An email has been sent to {email} with instructions on how to reset your password.</Text>
  )
}

export default React.memo(ForgotPasswordSuccess)
